"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundaryAssertionStateSchema = exports.BoundaryAssertionState = void 0;
const zod_1 = require("zod");
var BoundaryAssertionState;
(function (BoundaryAssertionState) {
    BoundaryAssertionState[BoundaryAssertionState["NotAsserting"] = 0] = "NotAsserting";
    BoundaryAssertionState[BoundaryAssertionState["Unresolved"] = 1] = "Unresolved";
    BoundaryAssertionState[BoundaryAssertionState["Implication"] = 2] = "Implication";
    BoundaryAssertionState[BoundaryAssertionState["Assertion"] = 3] = "Assertion";
})(BoundaryAssertionState || (exports.BoundaryAssertionState = BoundaryAssertionState = {}));
exports.BoundaryAssertionStateSchema = zod_1.z.nativeEnum(BoundaryAssertionState);
//# sourceMappingURL=BoundaryAssertionState.js.map